/** Decimal rate applied per plan month (0.01 = 1% improvement each new funding month). */
export function resolvePlanMonthLearningRate(state) {
  if (state?.dealIrrLearningFactor != null && state.dealIrrLearningFactor !== '') {
    const dealIrrRate = Number(state.dealIrrLearningFactor);
    if (Number.isFinite(dealIrrRate) && dealIrrRate >= 0) {
      return dealIrrRate;
    }
  }

  const legacyRatio = Number(state?.hillRoasEfficiencyRatio);
  if (Number.isFinite(legacyRatio) && legacyRatio > 1) {
    return legacyRatio - 1;
  }

  return 0;
}

/** First plan month (index 0) keeps the Hill vector; each later month compounds by (1 + rate). */
export function planMonthLearningMultiplier(learningRate, marketingMonthIndex) {
  const rate = Math.max(0, Number(learningRate) || 0);
  const origin = Math.max(0, Math.floor(Number(marketingMonthIndex) || 0));
  if (rate === 0) {
    return 1;
  }
  return (1 + rate) ** origin;
}

export const HILL_PLAN_MONTH_LEARNING_TOOLTIP =
  'Each new marketing month improves the full Hill ROAS vector by (1 + learning factor) raised to the plan month index. Month 0 keeps the fitted vector; month 1 multiplies by (1 + λ), month 2 by (1 + λ)², etc. Saturation K/(K+spend) is applied first, then the plan-month improvement.';
